// @flow
import {connect} from 'react-redux';
import {PickLine} from '../../components/common';
import {visibleSubscriptionsSelector} from '../../modules/Dashboard';
import I18n from '../../lib/i18n';
import {initESimReplacement} from '../../modules/SignUp/actions';
import {eSimSelectedSelector} from '../../modules/ESim';

import type {State} from '../../modules/reducers';
import type {
  StateProps,
  DispatchProps,
} from '../../components/common/PickLine/PickLine';
import {swapSim} from '../../modules/SuspendSwapTerminate';

const mapStateToProps = (state: State): StateProps => ({
  subscriptions: visibleSubscriptionsSelector(state),
  title: I18n.t('SignUp.SwapSim.title'),
  confirmButtonText: I18n.t('SignUp.SwapSim.button'),
  modalContent: () => I18n.t('SignUp.SwapSim.modalContent'),
  withGradient: true,
  loadingSelector: 'swapActivateSuccess',
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps: DispatchProps = {
  onConfirm: swapSim,
  onConfirmForEsim: initESimReplacement,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickLine);
